/**
 * Side-effect CSS for Naturals salon / face-identity shells only.
 * Keep these imports out of App.js so Nyafaz salon/skin do not inherit lux tokens.
 */
import './styles/EnterpriseSalonLuxTheme.css';
import './styles/PageBackground.css';
import './styles/Typography.css';
import './styles/ActionButtons.css';

export default function NaturalsSalonStyles() {
  return null;
}
